<template>
	<vs-prompt
		:active.sync="activePrompt"
		:title="$t('titleModalAddNewManager')"
		@accept="accept"
		:acceptText="$t('yes')"
		:cancelText="$t('cancel')"
		color="primary"
	>
		<div>
			{{ $t('promtModalAddNewManager') }}
		</div>
	</vs-prompt>
</template>

<script>
export default {
	name: "ModalAddNewManager",
	props: {
		active: {
			required: true,
			type: Boolean
		},
		orderNumber: {
			required: true,
			type: Number
		}
	},
	computed: {
		activePrompt: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
			}
		}
	},
	methods: {
		accept() {
			this.activePrompt = false;
			this.$emit("accept");
		},
	}
};
</script>

<style>

</style>